function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 4.5)",
    clipRule: "evenodd",
    fill: "#0DBD8B",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.201 2.7c0-1.4912 1.2088-2.7 2.7-2.7 9.9412 0 18 8.0589 18 18 0 1.4912-1.2088 2.7-2.7 2.7-1.4912 0-2.7-1.2088-2.7-2.7 0-6.9588-5.6412-12.6-12.6-12.6-1.4912 0-2.7-1.2088-2.7-2.7z",
    style: {
      fill: "#000",
      strokeWidth: 0.83333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.799 42.3c0 1.4912-1.2088 2.7-2.7 2.7-9.9411 0-18-8.0588-18-18 0-1.4912 1.2088-2.7 2.7-2.7 1.4912 0 2.7 1.2088 2.7 2.7 0 6.9588 5.6412 12.6 12.6 12.6 1.4912 0 2.7 1.2088 2.7 2.7z",
    style: {
      fill: "#000",
      strokeWidth: 0.83333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.7 28.8c-1.4912 0-2.7-1.2088-2.7-2.7-4.3454e-7 -9.9412 8.0589-18 18-18 1.4912 0 2.7 1.2089 2.7 2.7 0 1.4912-1.2088 2.7-2.7 2.7-6.9588 0-12.6 5.6412-12.6 12.6 0 1.4912-1.2088 2.7-2.7 2.7z",
    style: {
      fill: "#000",
      strokeWidth: 0.83333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.3 16.2c1.4912 0 2.7 1.2088 2.7 2.7 0 9.9412-8.0588 18-18 18-1.4912 0-2.7-1.2088-2.7-2.7 0-1.4912 1.2088-2.7 2.7-2.7 6.9588 0 12.6-5.6412 12.6-12.6 0-1.4912 1.2088-2.7 2.7-2.7z",
    style: {
      fill: "#000",
      strokeWidth: 0.83333
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.2a90face733f3835583147a9aeecc2c7.svg";
export { ForwardRef as ReactComponent };